import { MutationTree } from 'vuex';
import { IAgendaState } from './agenda-state.store';
import { AGENDA_SET_APPOINTMENTS, AGENDA_LOADING, AGENDA_SET_APPOINTMENT_BY_ID, AGENDA_SET_APPOINTMENT_BY_FIELD, AGENDA_SET_CURRENT_APPOINTMENT, AGENDA_PUSH_APPOINTMENT, AGENDA_SET_PARTIAL_PARAMETER, AGENDA_SET_DATE_APPOINTMENT, AGENDA_SET_LOADER_STATE } from './agenda-types.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
import { IAppointment } from '@/models/appointment';
import { IAppointmentParameter } from '../../models/appointment';

export const mutations: MutationTree<IAgendaState> = {
  [AGENDA_LOADING]: (state: IAgendaState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  }
  , [AGENDA_SET_APPOINTMENTS]: (state: IAgendaState,
    payload: { activityStatus: ActivityStatus, appointments: IAppointment[] }) => {
    state.appointments = payload.appointments;
    state.activityStatus = payload.activityStatus;
  }
  , [AGENDA_SET_APPOINTMENT_BY_ID]: (state: IAgendaState,
    payload: { activityStatus: ActivityStatus, appointment: IAppointment, originUpdatingAppointment: IAppointment }) => {
    const {appointment,originUpdatingAppointment} = payload
    if(originUpdatingAppointment)
    {
      state.appointment = {...appointment, fk_block:originUpdatingAppointment.fk_block}//payload.appointment;
    } else {
      state.appointment = payload.appointment;
    }

    state.originAppointment = payload.appointment;
    state.originUpdatingAppointment = payload.originUpdatingAppointment
    state.activityStatus = payload.activityStatus;
  }
  , [AGENDA_SET_APPOINTMENT_BY_FIELD]: (state: IAgendaState,
    payload: { [key: string]: any }) => {
    state.appointment = Object.assign({}, state.appointment, { ...payload });
  }
  , [AGENDA_SET_CURRENT_APPOINTMENT]: (state: IAgendaState,
    appointmentId: number) => {
    const appointment = state.appointments.find(a => a.id === appointmentId);
    if (appointment)
      state.appointment = appointment;
  }
  , [AGENDA_PUSH_APPOINTMENT]: (state: IAgendaState, { appointment, originalAppointment }) => {
    const appointmentIndex = state.appointments.findIndex(x => x.id === originalAppointment.id);
    if (appointmentIndex === -1) {
      state.appointments = [...state.appointments, originalAppointment]
    }
    else {
      Object.keys(originalAppointment).forEach(key => {
        state.appointments[appointmentIndex][key] = originalAppointment[key];
      })
    }
  }
  , [AGENDA_SET_DATE_APPOINTMENT]: (state: IAgendaState, { id, start_date, end_date }) => {
    const indexOf: number = state.appointments.findIndex(x => x.id === id);
    if (indexOf > -1) {
      state.appointments[indexOf].start_date = start_date;
      state.appointments[indexOf].end_date = end_date;
    }
  }
  , [AGENDA_SET_PARTIAL_PARAMETER]: (state: IAgendaState, partial: Partial<IAppointmentParameter>) => {
    state.appointmentParameter = Object.assign(state.appointmentParameter, partial);
  },
  [AGENDA_SET_LOADER_STATE]: (state: IAgendaState, payload: { key: string, value: boolean } ) => {
    state.loaders= new Map([
      ...state.loaders,
      [payload.key,payload.value]
    ])
  }
}



// WEBPACK FOOTER //
// ./src/store/agenda/agenda-mutations.store.ts